import {Team} from '@eitje/api'

export const TeamCell = ({getValue}) => {
	const id = getValue()
	const team = Team.useFind(id)
	return team.naam || null
}
